"use strict";
(self["webpackChunkshine_on"] = self["webpackChunkshine_on"] || []).push([[527],{

/***/ 3510:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

/* harmony import */ var scripts_vue_main__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(3200);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9346);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var scripts_vue_components_ProductItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1296);
/* harmony import */ var scripts_vue_components_VPic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(334);
/* harmony import */ var scripts_utils_breakpoints__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9508);
/* harmony import */ var _splidejs_vue_splide__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5493);
/* harmony import */ var _splidejs_splide_dist_css_themes_splide_default_min_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(881);
/**
 * Index Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Index/Home template.
 *
 * @namespace index
 * @file vendors@template.index.js
 * @file template.index.js
 *
 */










 // Carousels

document.querySelectorAll('.carousel').forEach(carousel => {
  let ID = carousel.parentNode.id;
  window.PSTheme.Vue[`Carousel${ID}`] = new (vue__WEBPACK_IMPORTED_MODULE_6___default())({
    name: 'Carousel',
    components: {
      vpic: scripts_vue_components_VPic__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z,
      slider: _splidejs_vue_splide__WEBPACK_IMPORTED_MODULE_4__/* .Splide */ .tv,
      slide: _splidejs_vue_splide__WEBPACK_IMPORTED_MODULE_4__/* .SplideSlide */ .jw
    },

    data() {
      return {
        mounted: false,
        carouselOptions: {
          arrows: false,
          autoplay: true,
          rewind: true
        }
      };
    },

    mounted() {
      this.mounted = true;
    }

  }).$mount(carousel);
}); // Product Sliders

document.querySelectorAll('.product-slider').forEach(product_slider => {
  let ID = product_slider.parentNode.id;
  window.PSTheme.Vue[`ProductSlider_${ID}`] = new (vue__WEBPACK_IMPORTED_MODULE_6___default())({
    name: 'ProductSlider',
    components: {
      slider: _splidejs_vue_splide__WEBPACK_IMPORTED_MODULE_4__/* .Splide */ .tv,
      slide: _splidejs_vue_splide__WEBPACK_IMPORTED_MODULE_4__/* .SplideSlide */ .jw,
      ProductItem: scripts_vue_components_ProductItem__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z
    },

    data() {
      return {
        mounted: false,
        sliderOptions: {
          perPage: 4,
          arrows: true,
          pagination: false,
          gap: '.125rem',
          breakpoints: {
            [scripts_utils_breakpoints__WEBPACK_IMPORTED_MODULE_3__/* .px_breakpoints["--tablet-lg-up"] */ .ku["--tablet-lg-up"]]: {
              perPage: 3
            },
            [scripts_utils_breakpoints__WEBPACK_IMPORTED_MODULE_3__/* .px_breakpoints["--tablet-up"] */ .ku["--tablet-up"]]: {
              perPage: 1,
              arrows: false,
              gap: '1rem',
              padding: {
                right: '5rem'
              }
            }
          }
        }
      };
    },

    mounted() {
      this.mounted = true;
    }

  }).$mount(product_slider);
}); // Instagam Feed

document.querySelector('.homepage__instagram-feed').addEventListener('elementinview', e => {
  let script_tag = document.createElement('script');
  script_tag.type = 'application/javascript';
  script_tag.src = 'https://showcase.abovemarket.com/embed/gallery/12274';
  script_tag.setAttribute('data-gallery-id', '12274');
  e.target.appendChild(script_tag);
});

/***/ }),

/***/ 9508:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "RS": function() { return /* binding */ mq_breakpoints; },
/* harmony export */   "ku": function() { return /* binding */ px_breakpoints; }
/* harmony export */ });
/* unused harmony export px_queries */
// EMs
let mq_breakpoints = {
  '--mobile-down': '(max-width: 25.99em)',
  '--mobile-up': '(min-width: 26em)',
  '--phablet-down': '(min-width: 32.49em)',
  '--phablet-up': '(min-width: 32.5em)',
  '--tablet-down': '(max-width: 39.99em)',
  '--tablet-up': '(min-width: 40em)',
  '--tablet-lg-down': '(min-width: 63.99em)',
  '--tablet-lg-up': '(min-width: 64em)',
  '--laptop-down': '(max-width: 71.99em)',
  '--laptop-up': '(min-width: 72em)',
  '--desktop-down': '(max-width: 99.99em)',
  '--desktop-up': '(min-width: 100em)',
  '--ultrawide': '(min-width: 125em)'
}; // Pixels

let px_breakpoints = {
  '--mobile-up': 416,
  '--phablet-up': 520,
  '--tablet-up': 640,
  '--tablet-lg-up': 1024,
  '--laptop-up': 1152,
  '--desktop-up': 1600,
  '--ultrawide': 2000
};
let px_queries = {
  '--mobile-up': '(min-width: 416px)',
  '--phablet-up': '(min-width: 520px)',
  '--tablet-up': '(min-width: 640px)',
  '--tablet-lg-up': '(min-width: 1024px)',
  '--laptop-up': '(min-width: 1152px)',
  '--desktop-up': '(min-width: 1600px)',
  '--ultrawide': '(min-width: 2000px)'
};


/***/ }),

/***/ 3200:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {


// EXTERNAL MODULE: ./node_modules/vue/dist/vue.min.js
var vue_min = __webpack_require__(9346);
var vue_min_default = /*#__PURE__*/__webpack_require__.n(vue_min);
;// CONCATENATED MODULE: ./src/scripts/vue/store/global.js

const store = vue_min_default().observable({
  menuActive: false,
  searchActive: false,
  notificationsActive: false,
  closeAnnouncement: false,
  customerCountry: 'NZ'
});
const actions = {
  openMenu() {
    store.menuActive = true;
  },

  toggleMenu() {
    if (store.menuActive) {
      this.closeAll();
    } else {
      this.closeAll();
      store.menuActive = true;
    }
  },

  toggleSearch() {
    store.searchActive = !store.searchActive;
  },

  toggleNotifications() {
    store.notificationsActive = !store.notificationsActive;
  },

  closeAll() {
    store.menuActive = false;
    store.searchActive = false;
    store.notificationsActive = false;
    window.PSTheme.Vue.Header.secondMenuIdx = null;
    window.PSTheme.Vue.Header.thirdMenuIdx = null;
  }

};
(vue_min_default()).prototype.$store = store;
(vue_min_default()).prototype.$actions = actions;
// EXTERNAL MODULE: ./src/scripts/utils/breakpoints.js
var breakpoints = __webpack_require__(9508);
// EXTERNAL MODULE: ./node_modules/@vue/composition-api/dist/vue-composition-api.mjs
var vue_composition_api = __webpack_require__(5706);
// EXTERNAL MODULE: ./node_modules/vue-screen/dist/vue-screen.esm.js
var vue_screen_esm = __webpack_require__(6768);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-currency/currency.js
var currency = __webpack_require__(1186);
// EXTERNAL MODULE: ./node_modules/@shopify/theme-images/images.js
var theme_images_images = __webpack_require__(3253);
;// CONCATENATED MODULE: ./src/scripts/vue/main.js







/* config */

(vue_min_default()).config.devtools = true;
(vue_min_default()).config.productionTip = false;
(vue_min_default()).config.silent = true;
/* extensions */

(vue_min_default()).prototype.$language = window.PSTheme.Language;
(vue_min_default()).prototype.$settings = window.PSTheme.Settings;

(vue_min_default()).prototype.$image = (src, size = '750x') => theme_images_images/* getSizedImageUrl */.M0(src, size);

(vue_min_default()).prototype.$preloadImages = (imgArray, size = '750x') => theme_images_images/* preload */.MA(imgArray, size);

(vue_min_default()).prototype.$money = amount => (0,currency/* formatMoney */.l)(amount, '${{amount}}');

(vue_min_default()).prototype.$isEmpty = obj => {
  if (obj && Object.keys(obj).length === 0 && obj.constructor === Object) return true;
};
/* plugins */


vue_min_default().use(vue_composition_api/* default */.ZP);
vue_min_default().use(vue_screen_esm/* default */.Z, {
  mobile_up: breakpoints/* px_breakpoints.--mobile-up */.ku["--mobile-up"],
  tablet_up: breakpoints/* px_breakpoints.--tablet-up */.ku["--tablet-up"],
  tablet_lg_up: breakpoints/* px_breakpoints.--tablet-lg-up */.ku["--tablet-lg-up"],
  laptop_up: breakpoints/* px_breakpoints.--laptop-up */.ku["--laptop-up"],
  desktop_up: breakpoints/* px_breakpoints.--desktop-up */.ku["--desktop-up"]
});

/***/ }),

/***/ 9918:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Loading; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&
var render = function (_h,_vm) {var _c=_vm._c;return _c('div',{class:[ 'site-loading', { 'activated': _vm.props.activated }],staticStyle:{"z-index":"100"}},[_vm._m(0)])}
var staticRenderFns = [function (_h,_vm) {var _c=_vm._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"circle one"}),_vm._v(" "),_c('div',{staticClass:"circle two"})])}]


;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=template&id=b5c84ec2&functional=true&

;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var Loadingvue_type_script_lang_js_ = ({
  name: 'Loading',
  props: ['activated']
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_Loadingvue_type_script_lang_js_ = (Loadingvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/Loading.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_Loadingvue_type_script_lang_js_,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* harmony default export */ var Loading = (component.exports);

/***/ }),

/***/ 1296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ProductItem; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductItem.vue?vue&type=template&id=7bad4973&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"product-item",attrs:{"href":_vm.url,"title":("Product: " + _vm.title),"aria-label":("Product: " + _vm.title)}},[_c('div',{staticClass:"product-item__image-wrapper",staticStyle:{"--aspect-ratio":"0.65"},on:{"mouseover":function($event){_vm.hover = _vm.$screen.laptop_up},"mouseleave":function($event){_vm.hover = false}}},[_c('transition',{attrs:{"name":"fade"}},[_c('VImg',{directives:[{name:"show",rawName:"v-show",value:(_vm.activeImage),expression:"activeImage"}],key:_vm.key,staticClass:"product-item__main-img",attrs:{"media":_vm.activeImage,"fixedSize":_vm.imageSize,"customClass":{ lazyload: _vm.hover, 'remove-transition': _vm.lazyloaded }},on:{"loaded":function($event){_vm.lazyloaded += 1}}})],1),_vm._v(" "),(_vm.hoverImage)?_c('VImg',{key:_vm.key,staticClass:"product-item__hover-img",attrs:{"media":_vm.hoverImage,"fixedSize":_vm.imageSize,"customClass":{ hovering: _vm.hover, 'remove-transition': _vm.lazyloaded }},on:{"loaded":function($event){_vm.lazyloaded += 1}}}):_vm._e(),_vm._v(" "),(_vm.label || (_vm.hover && _vm.product.variants.length > 1))?_c('div',{staticClass:"product-item__label",style:(_vm.labelStyle)},[(_vm.hover && _vm.product.variants.length > 1)?_c('div',{staticClass:"product-item__variants"},_vm._l((_vm.product.variants),function(variant){return _c('span',{key:variant.id,class:{ disabled: !variant.available }},[_vm._v("\n          "+_vm._s(variant.title)+"\n        ")])}),0):_c('span',[_vm._v(_vm._s(_vm.label))])]):_vm._e(),_vm._v(" "),(_vm.lazyloaded < 3)?_c('Loading',{attrs:{"activated":_vm.lazyloaded == 0 || _vm.hover}}):_vm._e()],1),_vm._v(" "),_c('span',{staticClass:"product-item__vendor"},[_vm._v("\n    "+_vm._s(_vm.product.vendor)+"\n  ")]),_vm._v(" "),_c('span',{staticClass:"product-item__title"},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]),_vm._v(" "),_c('p',{staticClass:"product-item__price"},[_c('span',{domProps:{"textContent":_vm._s(_vm.$money(_vm.price))}}),_vm._v(" "),(_vm.salePrice)?_c('s',{staticClass:"product__price--sale",domProps:{"textContent":_vm._s(_vm.$money(_vm.salePrice))}}):_vm._e()]),_vm._v(" "),_c('div',{ref:"insert-wishlist",staticClass:"product-item__wishlist"})])}
var staticRenderFns = []


// EXTERNAL MODULE: ./src/scripts/vue/components/VImg.vue + 3 modules
var VImg = __webpack_require__(3023);
// EXTERNAL MODULE: ./src/scripts/vue/components/Loading.vue + 4 modules
var Loading = __webpack_require__(9918);
;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/ProductItem.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ var ProductItemvue_type_script_lang_js_ = ({
  name: 'ProductItem',
  components: {
    VImg: VImg/* default */.Z,
    Loading: Loading/* default */.Z
  },
  props: ['product', 'collection', 'label_conf'],

  data() {
    return {
      key: 0,
      hover: false,
      lazyloaded: 0,
      imageSize: '550x'
    };
  },

  computed: {
    title() {
      return this.product.title.replace(this.product.vendor, '').trim();
    },

    handle() {
      return this.product.handle;
    },

    url() {
      return typeof this.collection !== 'undefined' ? `/collections/${this.collection}/products/${this.handle}` : `/products/${this.handle}`;
    },

    price() {
      return this.product.price;
    },

    salePrice() {
      return this.product.variants[0].compare_at_price;
    },

    images() {
      return this.product.images_info || this.product.media;
    },

    activeImage() {
      if (this.images.length === 0) return window.PSTheme.Settings.NoImage;
      return this.images[0];
    },

    hoverImage() {
      if (this.images.length > 1) return this.images[1];
    },

    tags() {
      return this.product.tags;
    },

    label() {
      if (window.PSTheme.Settings.Outlet && this.salePrice) {
        const discount = Math.round(100 - 100 * (this.price / this.salePrice));
        return `${discount}% off`;
      }

      const label = this.tags ? this.tags.find(tag => tag.includes('Label:')) : '';
      if (label) return label.replace('Label: ', '');
    },

    labelStyle() {
      const conf = this.label_conf ? this.label_conf[this.label] : null;
      const defaultStyle = window.PSTheme.Settings.Outlet ? 'color: var(--red); background: var(--soft-pink);' : 'color: var(--sage); background: var(--mint);';
      return conf ? `color: ${conf.color}; background: ${conf.background};` : defaultStyle;
    }

  },

  created() {
    const preloadImages = [];
    if (this.images) preloadImages.push(this.images[0].src ? this.images[0].src : this.images[0]);
    if (this.images.length > 1) preloadImages.push(this.images[1].src ? this.images[1].src : this.images[1]);
    this.$preloadImages(preloadImages, this.imageSize);
  },

  mounted() {
    if (window.PSTheme.Settings.Outlet === false) {
      const wishlist_btn = document.createComment(` include 'wishlist-button-collection' with '${this.product.id}' `);
      this.$refs['insert-wishlist'].appendChild(wishlist_btn);
    }
  },

  watch: {
    // re-render the template programmatically
    activeImage: {
      handler() {
        this.key = Math.random() * (999 - 0 + 1) << 0;
      },

      deep: true
    }
  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductItem.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_ProductItemvue_type_script_lang_js_ = (ProductItemvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/ProductItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_ProductItemvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var ProductItem = (component.exports);

/***/ }),

/***/ 3023:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VImg; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=template&id=ad5c73c6&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"lazyload vimg",class:_vm.customClass,attrs:{"src":_vm.dataURL,"data-src":_vm.fixedSize ? _vm.$image(_vm.media.src, _vm.fixedSize) : _vm.$image(_vm.media.src),"data-srcset":_vm.fixedSize ? '' : _vm.srcset,"data-sizes":"auto","alt":_vm.media.alt || _vm.$attrs.alt || 'Image'},on:{"lazyloaded":function($event){return _vm.$emit('loaded')}}})}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VImgvue_type_script_lang_js_ = ({
  name: 'VImg',
  props: ['media', 'fixedSize', 'customClass'],
  computed: {
    srcset() {
      if (this.fixedSize) return null;
      let srcset = this.$image(this.media.src, '200x') + ' 100w';
      this.media.width >= 200 ? srcset += `, ${this.$image(this.media.src, '400x')} 200w` : '';
      this.media.width >= 400 ? srcset += `, ${this.$image(this.media.src, '800x')} 400w` : '';
      this.media.width >= 600 ? srcset += `, ${this.$image(this.media.src, '1200x')} 600w` : '';
      this.media.width >= 800 ? srcset += `, ${this.$image(this.media.src, '1600x')} 800w` : '';
      this.media.width >= 1000 ? srcset += `, ${this.$image(this.media.src, '2000x')} 1000w` : '';
      this.media.width >= 1500 ? srcset += `, ${this.$image(this.media.src, '3000x')} 1500w` : '';
      this.media.width >= 2000 ? srcset += `, ${this.$image(this.media.src, '4000x')} 2000w` : '';
      return srcset;
    },

    // This will stop content reflow issue by supplying src attr with image aspect as a canvas
    dataURL() {
      const width = this.media.width;
      const height = this.media.height;
      if (!width || !height) return '';
      const w = 100;
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = height / width * w;
      return canvas.toDataURL();
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VImgvue_type_script_lang_js_ = (VImgvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/VImg.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_VImgvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VImg = (component.exports);

/***/ }),

/***/ 334:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ VPic; }
});

;// CONCATENATED MODULE: ./node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VPic.vue?vue&type=template&id=0cff2fc4&
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('picture',[_c('source',{attrs:{"media":_vm.media,"data-srcset":_vm.desktopSrcset}}),_vm._v(" "),_c('source',{attrs:{"data-srcset":_vm.mobileSrcset}}),_vm._v(" "),_c('img',{staticClass:"lazyload",attrs:{"src":_vm.dataURL,"alt":_vm.media.alt || _vm.$attrs.alt || 'Banner'}})])}
var staticRenderFns = []


;// CONCATENATED MODULE: ./node_modules/babel-loader/lib/index.js!./node_modules/vue-loader/lib/index.js??vue-loader-options!./src/scripts/vue/components/VPic.vue?vue&type=script&lang=js&
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
/* harmony default export */ var VPicvue_type_script_lang_js_ = ({
  name: 'VPic',
  props: ['media', 'mobile_media', 'desktop_media'],
  computed: {
    mobileSrcset() {
      let srcset = this.$image(this.mobile_media.src, '200x') + ' 100w';
      this.mobile_media.width >= 200 ? srcset += `, ${this.$image(this.mobile_media.src, '400x')} 200w` : '';
      this.mobile_media.width >= 400 ? srcset += `, ${this.$image(this.mobile_media.src, '800x')} 400w` : '';
      this.mobile_media.width >= 600 ? srcset += `, ${this.$image(this.mobile_media.src, '1200x')} 600w` : '';
      return srcset;
    },

    desktopSrcset() {
      let srcset = this.$image(this.desktop_media.src, '800x') + ' 400w';
      this.desktop_media.width >= 600 ? srcset += `, ${this.$image(this.desktop_media.src, '1200x')} 600w` : '';
      this.desktop_media.width >= 800 ? srcset += `, ${this.$image(this.desktop_media.src, '1600x')} 800w` : '';
      this.desktop_media.width >= 1000 ? srcset += `, ${this.$image(this.desktop_media.src, '2000x')} 1000w` : '';
      this.desktop_media.width >= 1500 ? srcset += `, ${this.$image(this.desktop_media.src, '3000x')} 1500w` : '';
      this.desktop_media.width >= 2000 ? srcset += `, ${this.$image(this.desktop_media.src, '4000x')} 2000w` : '';
      return srcset;
    },

    dataURL() {
      const width = this.$screen.tablet_lg_up ? this.desktop_media.width : this.mobile_media.width;
      const height = this.$screen.tablet_lg_up ? this.desktop_media.height : this.mobile_media.height;
      if (!width || !height) return '';
      const w = 100;
      const canvas = document.createElement('canvas');
      canvas.width = w;
      canvas.height = height / width * w;
      return canvas.toDataURL();
    }

  }
});
;// CONCATENATED MODULE: ./src/scripts/vue/components/VPic.vue?vue&type=script&lang=js&
 /* harmony default export */ var components_VPicvue_type_script_lang_js_ = (VPicvue_type_script_lang_js_); 
// EXTERNAL MODULE: ./node_modules/vue-loader/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1900);
;// CONCATENATED MODULE: ./src/scripts/vue/components/VPic.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.Z)(
  components_VPicvue_type_script_lang_js_,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var VPic = (component.exports);

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [346,383,67], function() { return __webpack_exec__(3510); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ }
]);